import PropTypes from "prop-types";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import EntityProxy from "data/util/EntityProxy";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import React from "react";
import Kids from "lib/dataentry/lib/dataentryform/formitems/Kids";

export class Layoutgridcell extends React.Component {
    render() {
        const {
            descriptor,
            activeRecord
        } = this.props;
        const config = Object.assign({}, Layoutgridcell.defaultProps.descriptor.config, descriptor.config);
        const Control = config.heading === true ? "th" : "td";
        const classes = [this.selector, "control-layout-gridcell"];
        if (config.controlOnly) {
            classes.push("control-only");
        }
        switch (config.align) {
            case "right":
                classes.push("text-right");
                break;
            case "center":
                classes.push("text-center");
                break;
            case "left":
            default:
                classes.push("text-left");
        }
        let children;
        if (config.heading === true && config.headingFor) {
            let label = null;
            try {
                label = entityFieldMetaStore.getInfo(activeRecord.entityKey, config.headingFor).name;
            } catch (e) {
                console.warn(`Layoutgridcell: headingFor references unknown field '${config.headingFor}' on entity '${activeRecord && activeRecord.entityKey}'`, e);
            }
            children = <span className="widget-label">{label}</span>;
        } else {
            children = <Kids {...this.props} controlOnly={config.controlOnly} />;
        }
        return (
            <Control
                key={descriptor.key}
                id={descriptor.id}
                className={classes.join(" ")}
                width={config.width}
                colSpan={config.colSpan}
            >
                {children}
            </Control>
        );
    }

}

Layoutgridcell.defaultProps = {
    descriptor: {
        config: {
            controlOnly: true,
            heading: false,
            align: "left"
        }
    }
};

Layoutgridcell.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes({
        controlOnly: PropTypes.bool,
        heading: PropTypes.bool,
        align: PropTypes.oneOf(["left", "right", "center"]),
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        colSpan: PropTypes.number,
        headingFor: PropTypes.string
    }, false, false)),
    fluxContext: PropTypes.string.isRequired,
    activeRecord: PropTypes.instanceOf(EntityProxy).isRequired
};

export default Layoutgridcell;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Layout/gridcell.js